/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/restrictions/special-settings/special-settings.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from '@angular/router/src/router_state';
import * as import11 from '../../../../../../public/upgrade/root/form-modal/form-modal.service';
import * as import12 from '../../../../../../public/upgrade/root/modal/modal.service';
import * as import13 from '../../../../../../public/upgrade/core/session.service';
import * as import14 from '../../../../../../public/upgrade/shared/eva-message/eva-message.component';
import * as import15 from '../../../shared/eva-message/eva-message.component.ngfactory';
import * as import16 from '@angular/core/src/linker/view_container';
import * as import17 from '@ngx-translate/core/src/translate.pipe';
import * as import18 from '@ngx-translate/core/src/translate.service';
import * as import19 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import20 from '../../../../../../public/upgrade/shared/pager/eva-pager.component';
import * as import21 from '../../../shared/pager/eva-pager.component.ngfactory';
import * as import22 from '@angular/core/src/linker/template_ref';
import * as import23 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import24 from '@angular/common/src/directives/ng_for';
import * as import25 from '../../../../../../public/upgrade/shared/eva-button-ghost/eva-button-ghost.component';
import * as import26 from '../../../shared/eva-button-ghost/eva-button-ghost.component.ngfactory';
import * as import27 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import28 from '../../../../../../public/upgrade/root/form-modal/form-modal.component';
import * as import29 from '../../../root/form-modal/form-modal.component.ngfactory';
import * as import30 from '../../../../../../public/upgrade/feature/restrictions/modal-special-settings/modal-special-settings.component';
import * as import31 from '../../../../../../public/upgrade/core/date.service';
import * as import32 from '../modal-special-settings/modal-special-settings.component.ngfactory';
import * as import33 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import34 from '../../../../../../public/upgrade/feature/restrictions/restrictions.service';
import * as import35 from '@angular/forms/src/form_builder';
import * as import36 from '@angular/common/src/directives/ng_if';
export class Wrapper_SpecialSettingsComponent {
  /*private*/ _eventHandler:Function;
  context:import0.SpecialSettingsComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  subscription0:any;
  subscription1:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any) {
    this._changed = false;
    this._changes = {};
    this.context = new import0.SpecialSettingsComponent(p0,p1,p2,p3,p4);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
    (this.subscription1 && this.subscription1.unsubscribe());
  }
  check_specialValues(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.specialValues = currValue;
      this._changes['specialValues'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  check_pointsOfSale(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.pointsOfSale = currValue;
      this._changes['pointsOfSale'] = new import1.SimpleChange(this._expr_1,currValue);
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if (changed) {
        this.context.ngOnChanges(this._changes);
        this._changes = {};
      }
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean,emit1:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.removeSpecialSetting.subscribe(_eventHandler.bind(view,'removeSpecialSetting'))); }
    if (emit1) { (this.subscription1 = this.context.updatePosRestriction.subscribe(_eventHandler.bind(view,'updatePosRestriction'))); }
  }
}
var renderType_SpecialSettingsComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_SpecialSettingsComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.SpecialSettingsComponent>;
  _GAService_0_3:import6.GAService;
  _SpecialSettingsComponent_0_4:Wrapper_SpecialSettingsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SpecialSettingsComponent_Host0,renderType_SpecialSettingsComponent_Host,import7.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'special-settings',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SpecialSettingsComponent0(this.viewUtils,this,0,this._el_0);
    this._GAService_0_3 = new import6.GAService();
    this._SpecialSettingsComponent_0_4 = new Wrapper_SpecialSettingsComponent(this.injectorGet(import10.ActivatedRoute,this.parentIndex),this.injectorGet(import11.FormModalService,this.parentIndex),this.injectorGet(import12.ModalService,this.parentIndex),this._GAService_0_3,this.injectorGet(import13.SessionService,this.parentIndex));
    this.compView_0.create(this._SpecialSettingsComponent_0_4.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import9.ComponentRef_<any>(0,this,this._el_0,this._SpecialSettingsComponent_0_4.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.GAService) && (0 === requestNodeIndex))) { return this._GAService_0_3; }
    if (((token === import0.SpecialSettingsComponent) && (0 === requestNodeIndex))) { return this._SpecialSettingsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SpecialSettingsComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._SpecialSettingsComponent_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SpecialSettingsComponentNgFactory:import9.ComponentFactory<import0.SpecialSettingsComponent> = new import9.ComponentFactory<import0.SpecialSettingsComponent>('special-settings',View_SpecialSettingsComponent_Host0,import0.SpecialSettingsComponent);
const styles_SpecialSettingsComponent:any[] = ([] as any[]);
class View_SpecialSettingsComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import14.EvaMessageComponent>;
  _EvaMessageComponent_2_3:import15.Wrapper_EvaMessageComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_SpecialSettingsComponent1,renderType_SpecialSettingsComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'eva-message',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import15.View_EvaMessageComponent0(this.viewUtils,this,2,this._el_2);
    this._EvaMessageComponent_2_3 = new import15.Wrapper_EvaMessageComponent();
    this.compView_2.create(this._EvaMessageComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.EvaMessageComponent) && (2 === requestNodeIndex))) { return this._EvaMessageComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.message;
    this._EvaMessageComponent_2_3.check_message(currVal_2_0_0,throwOnChange,false);
    this._EvaMessageComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SpecialSettingsComponent3 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _el_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _el_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  _text_57:any;
  _text_58:any;
  _text_59:any;
  _text_60:any;
  /*private*/ _expr_61:any;
  /*private*/ _expr_62:any;
  /*private*/ _expr_63:any;
  _pipe_translate_0:import17.TranslatePipe;
  _pipe_translate_1:import17.TranslatePipe;
  /*private*/ _expr_66:any;
  _pipe_translate_2:import17.TranslatePipe;
  _pipe_translate_3:import17.TranslatePipe;
  /*private*/ _expr_69:any;
  _pipe_translate_4:import17.TranslatePipe;
  _pipe_translate_5:import17.TranslatePipe;
  /*private*/ _expr_72:any;
  _pipe_translate_6:import17.TranslatePipe;
  /*private*/ _expr_74:any;
  _pipe_translate_7:import17.TranslatePipe;
  /*private*/ _expr_76:any;
  /*private*/ _expr_77:any;
  _pipe_translate_8:import17.TranslatePipe;
  /*private*/ _expr_79:any;
  /*private*/ _expr_80:any;
  _pipe_translate_9:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_SpecialSettingsComponent3,renderType_SpecialSettingsComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_61 = import1.UNINITIALIZED;
    this._expr_62 = import1.UNINITIALIZED;
    this._expr_63 = import1.UNINITIALIZED;
    this._expr_66 = import1.UNINITIALIZED;
    this._expr_69 = import1.UNINITIALIZED;
    this._expr_72 = import1.UNINITIALIZED;
    this._expr_74 = import1.UNINITIALIZED;
    this._expr_76 = import1.UNINITIALIZED;
    this._expr_77 = import1.UNINITIALIZED;
    this._expr_79 = import1.UNINITIALIZED;
    this._expr_80 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'tr',new import3.InlineArray2(2,'class','table-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'td',new import3.InlineArray4(4,'class','-eva-3-ellipsis table-col','qadata','name'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'td',new import3.InlineArray4(4,'class','-eva-3-tl table-col','qadata','anticipation-days'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_0,'td',new import3.InlineArray4(4,'class','-eva-3-tl table-col','qadata','min-days-reservation'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_0,'td',new import3.InlineArray4(4,'class','-eva-3-tl table-col','qadata','max-days-reservation'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_0,'td',new import3.InlineArray4(4,'class','-eva-3-tl table-col','qadata','from-date'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_0,'td',new import3.InlineArray4(4,'class','-eva-3-tl table-col','qadata','to-date'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_0,'td',new import3.InlineArray4(4,'class','-eva-3-tr table-col','style','overflow: inherit; padding-left: 40px !important;'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n                                    ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','eva-3-tooltip -top -left -sm'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n                                        ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'button',new import3.InlineArray2(2,'class','eva-3-link'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n                                            ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_24,'i',new import3.InlineArray2(2,'class','eva-3-icon-edit -eva-3-icon-sm'),(null as any));
    this._text_27 = this.renderer.createText(this._el_24,'\n                                            ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_24,'span',new import3.InlineArray2(2,'class','tooltip-container'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n                                            ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_28,'i',new import3.InlineArray2(2,'class','tooltip-marker'),(null as any));
    this._text_31 = this.renderer.createText(this._el_28,'\n                                            ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_28,'span',new import3.InlineArray2(2,'class','tooltip-content'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                                                ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'p',new import3.InlineArray2(2,'class','tooltip-text'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_32,'\n                                            ',(null as any));
    this._text_37 = this.renderer.createText(this._el_28,'\n                                        ',(null as any));
    this._text_38 = this.renderer.createText(this._el_24,'\n                                        ',(null as any));
    this._text_39 = this.renderer.createText(this._el_22,'\n                                    ',(null as any));
    this._text_40 = this.renderer.createText(this._el_20,'\n                                    ',(null as any));
    this._el_41 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','eva-3-tooltip -top -left -sm'),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'\n                                        ',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_41,'button',new import3.InlineArray2(2,'class','eva-3-link'),(null as any));
    this._text_44 = this.renderer.createText(this._el_43,'\n                                            ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_43,'i',new import3.InlineArray2(2,'class','eva-3-icon-trash -eva-3-icon-sm'),(null as any));
    this._text_46 = this.renderer.createText(this._el_43,'\n                                            ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_43,'span',new import3.InlineArray2(2,'class','tooltip-container'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                                            ',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_47,'i',new import3.InlineArray2(2,'class','tooltip-marker'),(null as any));
    this._text_50 = this.renderer.createText(this._el_47,'\n                                            ',(null as any));
    this._el_51 = import3.createRenderElement(this.renderer,this._el_47,'span',new import3.InlineArray2(2,'class','tooltip-content'),(null as any));
    this._text_52 = this.renderer.createText(this._el_51,'\n                                                ',(null as any));
    this._el_53 = import3.createRenderElement(this.renderer,this._el_51,'p',new import3.InlineArray2(2,'class','tooltip-text'),(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'',(null as any));
    this._text_55 = this.renderer.createText(this._el_51,'\n                                            ',(null as any));
    this._text_56 = this.renderer.createText(this._el_47,'\n                                        ',(null as any));
    this._text_57 = this.renderer.createText(this._el_43,'\n                                        ',(null as any));
    this._text_58 = this.renderer.createText(this._el_41,'\n                                    ',(null as any));
    this._text_59 = this.renderer.createText(this._el_20,'\n                                ',(null as any));
    this._text_60 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_2 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_3 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_4 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_5 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_6 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_7 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_24,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_24));
    this._pipe_translate_8 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_43,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_43));
    this._pipe_translate_9 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._el_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._text_55,
      this._text_56,
      this._text_57,
      this._text_58,
      this._text_59,
      this._text_60
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_61:any = import3.inlineInterpolate(1,'',this.context.$implicit.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_61,currVal_61)) {
      this.renderer.setElementProperty(this._el_2,'title',currVal_61);
      this._expr_61 = currVal_61;
    }
    const currVal_62:any = import3.inlineInterpolate(1,' ',this.context.$implicit.name,' ');
    if (import3.checkBinding(throwOnChange,this._expr_62,currVal_62)) {
      this.renderer.setText(this._text_3,currVal_62);
      this._expr_62 = currVal_62;
    }
    valUnwrapper.reset();
    const currVal_63:any = import3.inlineInterpolate(2,' ',this.context.$implicit.daysInAdvance,' ',((this.context.$implicit.daysInAdvance == 1)? valUnwrapper.unwrap(this._pipe_translate_0.transform('restrictions.DAY')): valUnwrapper.unwrap(this._pipe_translate_1.transform('restrictions.DAYS'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_63,currVal_63))) {
      this.renderer.setText(this._text_6,currVal_63);
      this._expr_63 = currVal_63;
    }
    valUnwrapper.reset();
    const currVal_66:any = import3.inlineInterpolate(2,' ',this.context.$implicit.minRentalLength,' ',((this.context.$implicit.minRentalLength == 1)? valUnwrapper.unwrap(this._pipe_translate_2.transform('restrictions.DAY')): valUnwrapper.unwrap(this._pipe_translate_3.transform('restrictions.DAYS'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_66,currVal_66))) {
      this.renderer.setText(this._text_9,currVal_66);
      this._expr_66 = currVal_66;
    }
    valUnwrapper.reset();
    const currVal_69:any = import3.inlineInterpolate(2,' ',this.context.$implicit.maxRentalLength,' ',((this.context.$implicit.maxRentalLength == 1)? valUnwrapper.unwrap(this._pipe_translate_4.transform('restrictions.DAY')): valUnwrapper.unwrap(this._pipe_translate_5.transform('restrictions.DAYS'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_69,currVal_69))) {
      this.renderer.setText(this._text_12,currVal_69);
      this._expr_69 = currVal_69;
    }
    valUnwrapper.reset();
    const currVal_72:any = import3.inlineInterpolate(1,' ',(this.context.$implicit.validity.always? valUnwrapper.unwrap(this._pipe_translate_6.transform('restrictions.SPECIAL_CONFIG.TABLE.alwaysDate')): this.context.$implicit.validity.from),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_72,currVal_72))) {
      this.renderer.setText(this._text_15,currVal_72);
      this._expr_72 = currVal_72;
    }
    valUnwrapper.reset();
    const currVal_74:any = import3.inlineInterpolate(1,' ',(this.context.$implicit.validity.always? valUnwrapper.unwrap(this._pipe_translate_7.transform('restrictions.SPECIAL_CONFIG.TABLE.alwaysDate')): this.context.$implicit.validity.to),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_74,currVal_74))) {
      this.renderer.setText(this._text_18,currVal_74);
      this._expr_74 = currVal_74;
    }
    const currVal_76:any = this.parentView.parentView.context.hideEditButton();
    if (import3.checkBinding(throwOnChange,this._expr_76,currVal_76)) {
      this.renderer.setElementProperty(this._el_24,'hidden',currVal_76);
      this._expr_76 = currVal_76;
    }
    valUnwrapper.reset();
    const currVal_77:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('common.EDIT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_77,currVal_77))) {
      this.renderer.setText(this._text_35,currVal_77);
      this._expr_77 = currVal_77;
    }
    const currVal_79:any = this.parentView.parentView.context.hideDeleteButton();
    if (import3.checkBinding(throwOnChange,this._expr_79,currVal_79)) {
      this.renderer.setElementProperty(this._el_43,'hidden',currVal_79);
      this._expr_79 = currVal_79;
    }
    valUnwrapper.reset();
    const currVal_80:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_9.transform('common.REMOVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_80,currVal_80))) {
      this.renderer.setText(this._text_54,currVal_80);
      this._expr_80 = currVal_80;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_24(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.openFormModal(this.context.$implicit,'edit')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_43(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.openModal(this.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_SpecialSettingsComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _el_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _el_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _el_26:any;
  _text_27:any;
  _text_28:any;
  _el_29:any;
  _el_30:any;
  _text_31:any;
  _text_32:any;
  _el_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _el_37:any;
  _el_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _anchor_47:any;
  /*private*/ _vc_47:import16.ViewContainer;
  _TemplateRef_47_5:any;
  _NgFor_47_6:import19.Wrapper_NgFor;
  _text_48:any;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _el_54:any;
  _text_55:any;
  _el_56:any;
  compView_56:import2.AppView<import20.EvaPagerComponent>;
  _EvaPagerComponent_56_3:import21.Wrapper_EvaPagerComponent;
  _text_57:any;
  _text_58:any;
  /*private*/ _expr_64:any;
  _pipe_translate_0:import17.TranslatePipe;
  /*private*/ _expr_66:any;
  _pipe_translate_1:import17.TranslatePipe;
  /*private*/ _expr_68:any;
  _pipe_translate_2:import17.TranslatePipe;
  /*private*/ _expr_70:any;
  _pipe_translate_3:import17.TranslatePipe;
  /*private*/ _expr_72:any;
  _pipe_translate_4:import17.TranslatePipe;
  /*private*/ _expr_74:any;
  _pipe_translate_5:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_SpecialSettingsComponent2,renderType_SpecialSettingsComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_64 = import1.UNINITIALIZED;
    this._expr_66 = import1.UNINITIALIZED;
    this._expr_68 = import1.UNINITIALIZED;
    this._expr_70 = import1.UNINITIALIZED;
    this._expr_72 = import1.UNINITIALIZED;
    this._expr_74 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-lg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-table'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','table-container'),(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_6,'i',new import3.InlineArray2(2,'class','eva-3-icon-arrow-bold-left table-nav-arrow-first'),(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'i',new import3.InlineArray2(2,'class','eva-3-icon-arrow-bold-right table-nav-arrow-last'),(null as any));
    this._text_9 = this.renderer.createText(this._el_6,'\n                        ',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n                        ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_6,'table',new import3.InlineArray4(4,'class','table-tag','id','table-restrictions-special'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                            ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_11,'thead',new import3.InlineArray2(2,'class','table-head'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'tr',new import3.InlineArray2(2,'class','table-heading'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                                ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'th',new import3.InlineArray2(2,'class','-eva-3-tl table-col table-heading-col'),(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_17,'span',new import3.InlineArray2(2,'class','table-content'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._text_20 = this.renderer.createText(this._el_15,'\n                                ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_15,'th',new import3.InlineArray2(2,'class','-eva-3-tl table-col table-heading-col'),(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_21,'span',new import3.InlineArray2(2,'class','table-content'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'',(null as any));
    this._text_24 = this.renderer.createText(this._el_15,'\n                                ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_15,'th',new import3.InlineArray2(2,'class','-eva-3-tl table-col table-heading-col'),(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_25,'span',new import3.InlineArray2(2,'class','table-content'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'',(null as any));
    this._text_28 = this.renderer.createText(this._el_15,'\n                                ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_15,'th',new import3.InlineArray2(2,'class','-eva-3-tl table-col table-heading-col'),(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_29,'span',new import3.InlineArray2(2,'class','table-content'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'',(null as any));
    this._text_32 = this.renderer.createText(this._el_15,'\n                                ',(null as any));
    this._el_33 = import3.createRenderElement(this.renderer,this._el_15,'th',new import3.InlineArray2(2,'class','-eva-3-tl table-col table-heading-col'),(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_33,'span',new import3.InlineArray2(2,'class','table-content'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_15,'\n                                ',(null as any));
    this._el_37 = import3.createRenderElement(this.renderer,this._el_15,'th',new import3.InlineArray2(2,'class','-eva-3-tl table-col table-heading-col'),(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_37,'span',new import3.InlineArray2(2,'class','table-content'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'',(null as any));
    this._text_40 = this.renderer.createText(this._el_15,'\n                                ',(null as any));
    this._el_41 = import3.createRenderElement(this.renderer,this._el_15,'th',new import3.InlineArray2(2,'class','-eva-3-tr table-col table-heading-col'),(null as any));
    this._text_42 = this.renderer.createText(this._el_15,'\n                            ',(null as any));
    this._text_43 = this.renderer.createText(this._el_13,'\n                            ',(null as any));
    this._text_44 = this.renderer.createText(this._el_11,'\n                            ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_11,'tbody',new import3.InlineArray2(2,'class','table-body'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n                            ',(null as any));
    this._anchor_47 = this.renderer.createTemplateAnchor(this._el_45,(null as any));
    this._vc_47 = new import16.ViewContainer(47,45,this,this._anchor_47);
    this._TemplateRef_47_5 = new import22.TemplateRef_(this,47,this._anchor_47);
    this._NgFor_47_6 = new import19.Wrapper_NgFor(this._vc_47.vcRef,this._TemplateRef_47_5,this.parentView.parentView.injectorGet(import23.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_48 = this.renderer.createText(this._el_45,'\n                            ',(null as any));
    this._text_49 = this.renderer.createText(this._el_11,'\n                        ',(null as any));
    this._text_50 = this.renderer.createText(this._el_6,'\n                    ',(null as any));
    this._text_51 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_52 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_53 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_54 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-12 -m-top-lg'),(null as any));
    this._text_55 = this.renderer.createText(this._el_54,'\n                ',(null as any));
    this._el_56 = import3.createRenderElement(this.renderer,this._el_54,'eva-pager',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_56 = new import21.View_EvaPagerComponent0(this.viewUtils,this,56,this._el_56);
    this._EvaPagerComponent_56_3 = new import21.Wrapper_EvaPagerComponent();
    this.compView_56.create(this._EvaPagerComponent_56_3.context);
    this._text_57 = this.renderer.createText(this._el_54,'\n            ',(null as any));
    this._text_58 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_2 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_3 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_4 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_5 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._el_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._el_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._el_26,
      this._text_27,
      this._text_28,
      this._el_29,
      this._el_30,
      this._text_31,
      this._text_32,
      this._el_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._el_37,
      this._el_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._anchor_47,
      this._text_48,
      this._text_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._el_54,
      this._text_55,
      this._el_56,
      this._text_57,
      this._text_58
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (47 === requestNodeIndex))) { return this._TemplateRef_47_5; }
    if (((token === import24.NgFor) && (47 === requestNodeIndex))) { return this._NgFor_47_6.context; }
    if (((token === import20.EvaPagerComponent) && (56 === requestNodeIndex))) { return this._EvaPagerComponent_56_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_47_0_0:any = this.parentView.context.page.pageItems;
    this._NgFor_47_6.check_ngForOf(currVal_47_0_0,throwOnChange,false);
    this._NgFor_47_6.ngDoCheck(this,this._anchor_47,throwOnChange);
    const currVal_56_0_0:any = this.parentView.context.page;
    this._EvaPagerComponent_56_3.check_config(currVal_56_0_0,throwOnChange,false);
    this._EvaPagerComponent_56_3.ngDoCheck(this,this._el_56,throwOnChange);
    this._vc_47.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_64:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('restrictions.SPECIAL_CONFIG.TABLE.header1')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_64,currVal_64))) {
      this.renderer.setText(this._text_19,currVal_64);
      this._expr_64 = currVal_64;
    }
    valUnwrapper.reset();
    const currVal_66:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('restrictions.SPECIAL_CONFIG.TABLE.header2')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_66,currVal_66))) {
      this.renderer.setText(this._text_23,currVal_66);
      this._expr_66 = currVal_66;
    }
    valUnwrapper.reset();
    const currVal_68:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('restrictions.SPECIAL_CONFIG.TABLE.header3')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_68,currVal_68))) {
      this.renderer.setText(this._text_27,currVal_68);
      this._expr_68 = currVal_68;
    }
    valUnwrapper.reset();
    const currVal_70:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('restrictions.SPECIAL_CONFIG.TABLE.header4')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_70,currVal_70))) {
      this.renderer.setText(this._text_31,currVal_70);
      this._expr_70 = currVal_70;
    }
    valUnwrapper.reset();
    const currVal_72:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('restrictions.SPECIAL_CONFIG.TABLE.header5')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_72,currVal_72))) {
      this.renderer.setText(this._text_35,currVal_72);
      this._expr_72 = currVal_72;
    }
    valUnwrapper.reset();
    const currVal_74:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('restrictions.SPECIAL_CONFIG.TABLE.header6')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_74,currVal_74))) {
      this.renderer.setText(this._text_39,currVal_74);
      this._expr_74 = currVal_74;
    }
    this.compView_56.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_47.destroyNestedViews();
    this.compView_56.destroy();
    this._EvaPagerComponent_56_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 47)) { return new View_SpecialSettingsComponent3(this.viewUtils,this,47,this._anchor_47,this._vc_47); }
    return (null as any);
  }
}
var renderType_SpecialSettingsComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_SpecialSettingsComponent,{});
export class View_SpecialSettingsComponent0 extends import2.AppView<import0.SpecialSettingsComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  compView_26:import2.AppView<import25.EvaButtonGhostComponent>;
  _EvaButtonGhostComponent_26_3:import26.Wrapper_EvaButtonGhostComponent;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _anchor_30:any;
  /*private*/ _vc_30:import16.ViewContainer;
  _TemplateRef_30_5:any;
  _NgIf_30_6:import27.Wrapper_NgIf;
  _text_31:any;
  _text_32:any;
  _anchor_33:any;
  /*private*/ _vc_33:import16.ViewContainer;
  _TemplateRef_33_5:any;
  _NgIf_33_6:import27.Wrapper_NgIf;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  compView_36:import2.AppView<import28.FormModalComponent>;
  _FormModalComponent_36_3:import29.Wrapper_FormModalComponent;
  _text_37:any;
  _text_38:any;
  _el_39:any;
  compView_39:import2.AppView<import30.ModalSpecialSettingsComponent>;
  _DateService_39_3:import31.DateService;
  _GAService_39_4:import6.GAService;
  _ModalSpecialSettingsComponent_39_5:import32.Wrapper_ModalSpecialSettingsComponent;
  _text_40:any;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  /*private*/ _expr_58:any;
  _pipe_translate_0:import17.TranslatePipe;
  /*private*/ _expr_60:any;
  _pipe_translate_1:import17.TranslatePipe;
  /*private*/ _expr_62:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SpecialSettingsComponent0,renderType_SpecialSettingsComponent,import7.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_58 = import1.UNINITIALIZED;
    this._expr_60 = import1.UNINITIALIZED;
    this._expr_62 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_15,'\n            ',(null as any));
    this._text_20 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._text_21 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-lg'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n            ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'div',new import3.InlineArray4(4,'class','col -lg-4 -md-4 -sm-12','qadata','special-settings-btn'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_24,'eva-button-ghost',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_26 = new import26.View_EvaButtonGhostComponent0(this.viewUtils,this,26,this._el_26);
    this._EvaButtonGhostComponent_26_3 = new import26.Wrapper_EvaButtonGhostComponent();
    this.compView_26.create(this._EvaButtonGhostComponent_26_3.context);
    this._text_27 = this.renderer.createText(this._el_24,'\n            ',(null as any));
    this._text_28 = this.renderer.createText(this._el_22,'\n            ',(null as any));
    this._text_29 = this.renderer.createText(this._el_22,'\n            ',(null as any));
    this._anchor_30 = this.renderer.createTemplateAnchor(this._el_22,(null as any));
    this._vc_30 = new import16.ViewContainer(30,22,this,this._anchor_30);
    this._TemplateRef_30_5 = new import22.TemplateRef_(this,30,this._anchor_30);
    this._NgIf_30_6 = new import27.Wrapper_NgIf(this._vc_30.vcRef,this._TemplateRef_30_5);
    this._text_31 = this.renderer.createText(this._el_22,'\n        ',(null as any));
    this._text_32 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._anchor_33 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_33 = new import16.ViewContainer(33,2,this,this._anchor_33);
    this._TemplateRef_33_5 = new import22.TemplateRef_(this,33,this._anchor_33);
    this._NgIf_33_6 = new import27.Wrapper_NgIf(this._vc_33.vcRef,this._TemplateRef_33_5);
    this._text_34 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_35 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_2,'form-modal',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_36 = new import29.View_FormModalComponent0(this.viewUtils,this,36,this._el_36);
    this._FormModalComponent_36_3 = new import29.Wrapper_FormModalComponent(this.parentView.injectorGet(import11.FormModalService,this.parentIndex));
    this._text_37 = this.renderer.createText((null as any),'\n            ',(null as any));
    this._text_38 = this.renderer.createText((null as any),'\n            ',(null as any));
    this._el_39 = import3.createRenderElement(this.renderer,(null as any),'modal-special-settings',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_39 = new import32.View_ModalSpecialSettingsComponent0(this.viewUtils,this,39,this._el_39);
    this._DateService_39_3 = new import31.DateService();
    this._GAService_39_4 = new import6.GAService();
    this._ModalSpecialSettingsComponent_39_5 = new import32.Wrapper_ModalSpecialSettingsComponent(this.parentView.injectorGet(import10.ActivatedRoute,this.parentIndex),this.parentView.injectorGet(import11.FormModalService,this.parentIndex),this.parentView.injectorGet(import33.NotificationService,this.parentIndex),this.parentView.injectorGet(import34.RestrictionsService,this.parentIndex),this.parentView.injectorGet(import35.FormBuilder,this.parentIndex),this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this._DateService_39_3,this._GAService_39_4);
    this.compView_39.create(this._ModalSpecialSettingsComponent_39_5.context);
    this._text_40 = this.renderer.createText((null as any),'\n        ',(null as any));
    this.compView_36.create(this._FormModalComponent_36_3.context);
    this._text_41 = this.renderer.createText(this._el_2,'\n\n    ',(null as any));
    this._text_42 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_43 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_26,new import3.InlineArray2(2,'action',(null as any)),this.eventHandler(this.handleEvent_26));
    this._EvaButtonGhostComponent_26_3.subscribe(this,this.eventHandler(this.handleEvent_26),true);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_39,new import3.InlineArray2(2,'savePosRestriction',(null as any)),this.eventHandler(this.handleEvent_39));
    this._ModalSpecialSettingsComponent_39_5.subscribe(this,this.eventHandler(this.handleEvent_39),true);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._anchor_30,
      this._text_31,
      this._text_32,
      this._anchor_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._text_41,
      this._text_42,
      this._text_43
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.EvaButtonGhostComponent) && (26 === requestNodeIndex))) { return this._EvaButtonGhostComponent_26_3.context; }
    if (((token === import22.TemplateRef) && (30 === requestNodeIndex))) { return this._TemplateRef_30_5; }
    if (((token === import36.NgIf) && (30 === requestNodeIndex))) { return this._NgIf_30_6.context; }
    if (((token === import22.TemplateRef) && (33 === requestNodeIndex))) { return this._TemplateRef_33_5; }
    if (((token === import36.NgIf) && (33 === requestNodeIndex))) { return this._NgIf_33_6.context; }
    if (((token === import31.DateService) && (39 === requestNodeIndex))) { return this._DateService_39_3; }
    if (((token === import6.GAService) && (39 === requestNodeIndex))) { return this._GAService_39_4; }
    if (((token === import30.ModalSpecialSettingsComponent) && (39 === requestNodeIndex))) { return this._ModalSpecialSettingsComponent_39_5.context; }
    if (((token === import28.FormModalComponent) && ((36 <= requestNodeIndex) && (requestNodeIndex <= 40)))) { return this._FormModalComponent_36_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_26_0_0:any = this.context.addSpecialSettings;
    this._EvaButtonGhostComponent_26_3.check_buttonGhost(currVal_26_0_0,throwOnChange,false);
    this._EvaButtonGhostComponent_26_3.ngDoCheck(this,this._el_26,throwOnChange);
    const currVal_30_0_0:boolean = (!!this.context.pointsOfSale && (this.context.pointsOfSale.length == 0));
    this._NgIf_30_6.check_ngIf(currVal_30_0_0,throwOnChange,false);
    this._NgIf_30_6.ngDoCheck(this,this._anchor_30,throwOnChange);
    const currVal_33_0_0:boolean = (!!((this.context.page == null)? (null as any): this.context.page.pageItems) && (this.context.specialValues.length > 0));
    this._NgIf_33_6.check_ngIf(currVal_33_0_0,throwOnChange,false);
    this._NgIf_33_6.ngDoCheck(this,this._anchor_33,throwOnChange);
    const currVal_36_0_0:any = this.context.title;
    this._FormModalComponent_36_3.check_title(currVal_36_0_0,throwOnChange,false);
    const currVal_36_0_1:any = this.context.name;
    this._FormModalComponent_36_3.check_name(currVal_36_0_1,throwOnChange,false);
    this._FormModalComponent_36_3.ngDoCheck(this,this._el_36,throwOnChange);
    const currVal_39_0_0:any = this.context.pointsOfSale;
    this._ModalSpecialSettingsComponent_39_5.check_pointsOfSale(currVal_39_0_0,throwOnChange,false);
    const currVal_39_0_1:any = this.context.selectedSpecialValue;
    this._ModalSpecialSettingsComponent_39_5.check_selectedSpecialValue(currVal_39_0_1,throwOnChange,false);
    const currVal_39_0_2:any = this.context.specialValues;
    this._ModalSpecialSettingsComponent_39_5.check_restrictions(currVal_39_0_2,throwOnChange,false);
    const currVal_39_0_3:any = this.context.openedModal;
    this._ModalSpecialSettingsComponent_39_5.check_openModal(currVal_39_0_3,throwOnChange,false);
    const currVal_39_0_4:any = this.context.posListForSelect;
    this._ModalSpecialSettingsComponent_39_5.check_posListForSelect(currVal_39_0_4,throwOnChange,false);
    this._ModalSpecialSettingsComponent_39_5.ngDoCheck(this,this._el_39,throwOnChange);
    this._vc_30.detectChangesInNestedViews(throwOnChange);
    this._vc_33.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_58:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('restrictions.SPECIAL_CONFIG')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_58,currVal_58))) {
      this.renderer.setText(this._text_9,currVal_58);
      this._expr_58 = currVal_58;
    }
    valUnwrapper.reset();
    const currVal_60:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('restrictions.SPECIAL_CONFIG.INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_60,currVal_60))) {
      this.renderer.setText(this._text_18,currVal_60);
      this._expr_60 = currVal_60;
    }
    const currVal_62:any = this.context.hideAddNewConfiguration();
    if (import3.checkBinding(throwOnChange,this._expr_62,currVal_62)) {
      this.renderer.setElementProperty(this._el_26,'hidden',currVal_62);
      this._expr_62 = currVal_62;
    }
    this.compView_26.internalDetectChanges(throwOnChange);
    this.compView_36.internalDetectChanges(throwOnChange);
    this.compView_39.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_30.destroyNestedViews();
    this._vc_33.destroyNestedViews();
    this.compView_26.destroy();
    this.compView_36.destroy();
    this.compView_39.destroy();
    this._EvaButtonGhostComponent_26_3.ngOnDestroy();
    this._ModalSpecialSettingsComponent_39_5.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 36) && (ngContentIndex == 0))) {
      cb(this._text_37,ctx);
      cb(this._text_38,ctx);
      cb(this._el_39,ctx);
      cb(this._text_40,ctx);
    }
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 30)) { return new View_SpecialSettingsComponent1(this.viewUtils,this,30,this._anchor_30,this._vc_30); }
    if ((nodeIndex == 33)) { return new View_SpecialSettingsComponent2(this.viewUtils,this,33,this._anchor_33,this._vc_33); }
    return (null as any);
  }
  handleEvent_26(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'action')) {
      const pd_sub_0:any = ((<any>this.context.openFormModal($event,'new')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_39(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'savePosRestriction')) {
      const pd_sub_0:any = ((<any>this.context.savePosRestriction($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/restrictions/special-settings/special-settings.component.ngfactory.ts